// import invariant from 'invariant';
import { SearchFilterKey, SearchFilterOption } from '../components/searchFilter/types';

interface CheckboxListProps {
  radio?: boolean;
  name: SearchFilterKey;
  options: SearchFilterOption[];
  selectedIndex: number | number[];
  onChange: (
    option: SearchFilterOption,
    selectedIndex: number | number[],
    event?: React.ChangeEvent,
  ) => void;
  className?: string;
  withoutHtml?: boolean;
}

const idPrefix = 'checkboxlist-id';

export default function CheckboxList({
  radio,
  name,
  options,
  selectedIndex,
  onChange,
  className,
  withoutHtml,
}: CheckboxListProps): JSX.Element {
  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>, optionIndex: number): void {
    if (!e.target) {
      return;
    }
    const targetedOption = options[optionIndex];

    // Single select
    if (radio) {
      onChange(targetedOption, optionIndex, e);
      return;
    }

    // Multi select
    if (Array.isArray(selectedIndex)) {
      const selectedIndices = [...selectedIndex];
      console.log(selectedIndices);
      const selectedIndicesIndex = selectedIndices.indexOf(optionIndex);
      if (selectedIndicesIndex === -1) {
        // Wasn't selected before, add it to the list of selected indices
        selectedIndices.push(optionIndex);
      } else {
        // Was selected before, remove it from the list of selected indices
        selectedIndices.splice(selectedIndicesIndex, 1);
      }
      onChange(targetedOption, selectedIndices, e);
    }
  }

  function getInputType(): string {
    return radio ? 'radio' : 'checkbox';
  }

  function isChecked(i: number): boolean {
    if (radio) {
      return selectedIndex === i;
    }
    if (typeof selectedIndex === 'number') {
      return false;
    }
    return selectedIndex.includes(i);
  }

  function idKey(value: number | string): string {
    return [idPrefix, name, value.toString()].join('-');
  }

  return (
    <ul className={className}>
      {options.map((option, i) => (
        <li key={option.value}>
          <label htmlFor={idKey(option.value)}>
            <input
              type={getInputType()}
              name={name}
              id={idKey(option.value)}
              value={option.value}
              checked={isChecked(i)}
              onChange={(e): void => handleOnChange(e, i)}
            />
            {withoutHtml ? (
              <span>{option.label}</span>
            ) : (
              <span dangerouslySetInnerHTML={{ __html: ` ${option.label}` }} />
            )}
          </label>
        </li>
      ))}
    </ul>
  );
}

const defaultProps: Pick<CheckboxListProps, 'radio' | 'className' | 'withoutHtml'> = {
  radio: false,
  className: undefined,
  withoutHtml: false,
};

CheckboxList.defaultProps = defaultProps;
